import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { updateBotValue, highlightSearchedResult, blockUiFun, reloginUser } from '../../Redux/Actions/uiActions';
import './SingleDataDistributor.scss';
import PopOverMenu from '../../Elements/Atoms/PopOverMenu';
import ToggleButton from '../../Elements/Molecules/ToggleButton';
import CreatePopMenu from '../../Elements/Molecules/CreatePopMenu';
import Buttton from '../../Elements/Atoms/Button';
import ImgTag from '../../Elements/Atoms/ImgTag';
import { updateSpecificValue, upload } from '../../Utils/index';
// import Input from '../../Elements/Atoms/Input';

import addOptionIcon from '../../../assets/icons/ic_add_blue.png';
import clearIcon from '../../../assets/icons/ic_close_light_grey.png';
import ImagePopOver from '../../Elements/Atoms/ImagePopOver';
import attachImage from '../../../assets/icons/ic_attachment.png';
import dropdownIcon from '../../../assets/icons/ic_expand_blue.png';
import ColorPopOver from '../../Elements/Atoms/ColorPopOver';
import MultyImagePopOver from '../../Elements/Atoms/MultyImagePopOver';
import MultyImagePopOverNew from '../../Elements/Atoms/MultyImagePopOverNew';
import BLOCK_ICON from '../../../assets/icons/ic_red_block.png';
import { checkFeatureFlag } from '../../../constants';

class SingleDataDistributor extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    getReadableName = (actualName) => {
        if (actualName) {
            const readableName = actualName.toLowerCase().replace(/-|_|\//g, ' ');
            return readableName;
        }
    };

    addSelectBotValue = () => {
        return (
            <span className='eb-icon-btn-image'>
                <ImgTag
                    className='image'
                    src={addOptionIcon}
                    alt='Close'
                />
            </span>
        );
    };

    getConfDetails = (array) => {
        let tempConfString = '';
        for (let index = 0; index < array.length; index++) {
            tempConfString += array[index];
            if (index < (array.length - 1)) {
                tempConfString += ' > ';
            }
        }
        return tempConfString;
    };

    radioButtonInputFun = (tempRadioArray, parentArray, props, editableBotData) => {
        tempRadioArray.forEach(element => {
            if (parentArray[(parentArray.length - 1)] === element) {
                props.updateBotValue(updateSpecificValue(true, parentArray, editableBotData, 'radioType'));
            } else {
                const tempArray = JSON.parse(JSON.stringify(parentArray));
                tempArray.pop();
                tempArray.push(element);
                props.updateBotValue(updateSpecificValue(false, tempArray, editableBotData, 'radioType'));
            }
        });
    }

    inputUpdate = (e, parentArray, props, isArrayType, tempRadioArray, arrayData, arrayIndex, attachmentType, importedType, importedVal, colorType, colorVal) => {
        let currentTargetElem, inputType, value, editableBotData, inputClassType, tempParentArr, isDisabled;
        editableBotData = props.tempdata.isGeneric ? props.genericBotData : props.editableBotData;
        if (importedVal && importedVal !== '') {

        } else {
            currentTargetElem = e.target;
            inputType = currentTargetElem.type;
            value = currentTargetElem.value;
            inputClassType = currentTargetElem.classList[0];
            isDisabled = currentTargetElem.getAttribute('data-prefilled');
        }

        if(colorType === 'color') {
            inputType = 'color'
            isDisabled = 'true';
            value = colorVal;
        }

        if (props.tempdata && props.tempdata.parentArray) {
            let tempArr = [];
            parentArray.forEach((elm, i) => {
                if (elm.indexOf('Object ') > -1) {
                    let searchedElem = elm.slice(7, 8);
                    searchedElem = parseInt(searchedElem) - 1;
                    tempArr.push('VALUE');
                    tempArr.push(searchedElem);
                } else {
                    tempArr.push(elm);
                }
            });
            parentArray = tempArr;
        }

        if (inputType === 'checkbox') {
            value = currentTargetElem.checked;
            props.updateBotValue(updateSpecificValue(value, parentArray, editableBotData, 'toggle'));
        } else if (inputType === 'radio') {
            let lastELm = parentArray[parentArray.length - 1];
            let secondLastELm = parentArray[parentArray.length - 2];
            let thirdLastELm = parentArray[parentArray.length - 3];
            this.radioButtonInputFun(tempRadioArray, parentArray, props, editableBotData);
            if (lastELm && secondLastELm && thirdLastELm && thirdLastELm === 'CHAT_HEADER') {
                if (parentArray[parentArray.length - 4] === 'USER_SIDE_SETTINGS') {
                    tempParentArr = ["CHATBOT", "CUSTOMISE_YOUR_BOT", "CHAT_HEADER", "TYPE"];
                } else {
                    tempParentArr = ["USER_SIDE_SETTINGS", "CHAT_HEADER", "TYPE"];
                }
                tempParentArr.push(lastELm);
                this.radioButtonInputFun(tempRadioArray, tempParentArr, props, editableBotData);
            } else {
                // do nothing
            }

        } else if (inputType === 'number') {
            try {
                value = parseInt(value);
            } catch (e) {

            }
            if (isArrayType) {
                arrayData[arrayIndex] = value;
                props.updateBotValue(updateSpecificValue(arrayData, parentArray, editableBotData, 'array'));
            } else if (attachmentType) {
                props.updateBotValue(updateSpecificValue(value, parentArray, editableBotData, 'attachment'));
            } else {
                if (value < 0) {
                    alert('The value should not be negative');
                    props.updateBotValue(updateSpecificValue(0, parentArray, editableBotData, 'text'));
                    currentTargetElem.value = 0;
                } else {
                    props.updateBotValue(updateSpecificValue(value, parentArray, editableBotData, 'text'));
                }
            }
        } else if (inputType === 'text') {
            if (isArrayType) {
                arrayData[arrayIndex] = value;
                props.updateBotValue(updateSpecificValue(arrayData, parentArray, editableBotData, 'array'));
            } else if (attachmentType) {
                props.updateBotValue(updateSpecificValue(value, parentArray, editableBotData, 'attachment'));
            } else {
                props.updateBotValue(updateSpecificValue(value, parentArray, editableBotData, 'text'));
                let lastELm = parentArray[parentArray.length - 1];
                let secondLastELm = parentArray[parentArray.length - 2];
                tempParentArr = parentArray;
                if (lastELm && lastELm === 'TEXT' && secondLastELm && secondLastELm === 'CHAT_HEADER') {
                    if (parentArray[parentArray.length - 3] === 'USER_SIDE_SETTINGS') {
                        tempParentArr = ["CHATBOT", "CUSTOMISE_YOUR_BOT", "CHAT_HEADER", "TEXT"];
                    } else {
                        tempParentArr = ["USER_SIDE_SETTINGS", "CHAT_HEADER", "TEXT"];
                    }
                    props.updateBotValue(updateSpecificValue(value, tempParentArr, editableBotData, 'text'));
                } else {
                    // do nothing
                }
            }
        } else if (inputType === 'color') {
            if (isDisabled === 'true') {
                props.updateBotValue(updateSpecificValue(value, parentArray, editableBotData, 'text'));
            } else {
                props.updateBotValue(updateSpecificValue(value, parentArray, editableBotData, 'text'));
                props.updateBotValue(updateSpecificValue(arrayData, [...parentArray, 'ARRAY'], editableBotData, 'arrAttachment'));
            }
        } else if ((inputType === 'file' || inputType === undefined) && importedVal !== '') {
            if(importedType === 'image') {
                props.updateBotValue(updateSpecificValue(importedVal, parentArray, editableBotData, 'text'));
            } else if(importedType === 'drop-shadow') {
                props.updateBotValue(updateSpecificValue(importedVal, parentArray, editableBotData, 'array'));
            } else if(importedType === 'img-arr') {
                props.updateBotValue(updateSpecificValue(importedVal, parentArray, editableBotData, 'arrAttachment'));
            } else if(importedType === 'img-group-arr') {
                props.updateBotValue(updateSpecificValue(importedVal, parentArray, editableBotData, 'arrAttachment'));
            } else if(importedType === 'color-array-field') {
                props.updateBotValue(updateSpecificValue(importedVal, parentArray, editableBotData, 'arrAttachment'));
            } else if(importedType === 'drop-down') {
                importedVal = parseInt(importedVal);
                props.updateBotValue(updateSpecificValue(importedVal, parentArray, editableBotData, 'text'));
                this.setState({ fontMenuOpen: !this.state.fontMenuOpen });
            } else if (inputClassType === 'color-input-inner-container') {
                let value = currentTargetElem.getAttribute('value');
                props.updateBotValue(updateSpecificValue(value, parentArray, editableBotData, 'text'));
            } else if (colorType && colorType === 'false') {
                props.updateBotValue(updateSpecificValue(false, [...parentArray, 'VALUE'], editableBotData, 'arrAttachment'));
            } else if (colorType && colorType === 'gradient') {
                props.updateBotValue(updateSpecificValue(colorVal, [...parentArray, 'VALUE'], editableBotData, 'arrAttachment'));
            }
        } else {
            alert('Input type not described to update -> ' + inputType);
        }
    };

    removeCurrentField = (e, parentArray, props, arrayData, arrayIndex, arrType) => {
        const newArr = arrayData.filter((e, i) => i !== arrayIndex);
        let editableBotData = props.tempdata.isGeneric ? props.genericBotData : props.editableBotData;
        if (arrType === 'arrAttachment') {
            props.updateBotValue(updateSpecificValue(newArr, parentArray, editableBotData, 'arrAttachment'));
        } else {
            props.updateBotValue(updateSpecificValue(newArr, parentArray, editableBotData, 'array'));
        }
    };

    loadRemoveIcon = (parentArray, props, arrayData, arrayIndex, arrType) => {
        return (
            <span className='array-input-clear-iocn-wrapper' onClick={
                (e) => {
                    this.removeCurrentField(e, parentArray, props, arrayData, arrayIndex, arrType);
                }
            }>
                <ImgTag
                    alt='clear'
                    className='array-input-clear-iocn'
                    src={clearIcon}
                />
            </span>
        );
    };

    attchmentDistributor = (tempdata, props) => {
        let dataKeys = Object.keys(tempdata.data);
        let editableBotData = props.tempdata.isGeneric ? props.genericBotData : props.editableBotData;
        return (
            <div className='config-group-area'>
                <div className='config-inputs-wrapper'>
                    {
                        dataKeys.map((key, i) => {
                            let containerClassName = 'character-input-box';
                            if (tempdata.data[key].length < 11) {
                                containerClassName = 'character-input-box field-size-xs';
                            } else if (tempdata.data[key].length < 22) {
                                containerClassName = 'character-input-box field-size-sm';
                            } else if (tempdata.data[key].length < 45) {
                                containerClassName = 'character-input-box field-size-md';
                            } else if (tempdata.data[key].length < 70) {
                                containerClassName = 'character-input-box field-size-lg';
                            } else {
                                containerClassName = 'character-input-box field-size-xl';
                            }
                            let parentMatch = false;
                            if (props.highlightSearchedData && props.highlightSearchedData.parent) {
                                parentMatch = JSON.stringify([...tempdata.parentArray, key]) === JSON.stringify(props.highlightSearchedData.parent);
                            }
                            let labelClassName = 'config-title' + (props.highlightSearchedData && props.highlightSearchedData.parent && props.highlightSearchedData.parent.length && parentMatch ? ' highlighted' : '');

                            if (typeof (tempdata.data[key]) === 'object') {
                                if (tempdata.data[key] && key !== 'PAYLOAD') {
                                    let arraycontainerClassName = 'array-input-box';
                                    if (props.highlightSearchedData && props.highlightSearchedData.parent) {
                                        parentMatch = JSON.stringify([...tempdata.parentArray, key]) === JSON.stringify(props.highlightSearchedData.parent);
                                        labelClassName = 'config-title' + (props.highlightSearchedData.parent && props.highlightSearchedData.parent.length && parentMatch ? ' highlighted' : '');
                                    }
                                    return (
                                        <div className='config-input-block' key={i}>
                                            {parentMatch ? this.addTempDivToScroll() : null}
                                            <div className='config-label'>
                                                <label className={labelClassName}>{this.getReadableName(key)}</label>
                                                <div className='more-options-btn-wrapper popover-inactive'>
                                                    <PopOverMenu
                                                        groupDesc={'Attachment Object'}
                                                        groupType={tempdata.data.ELEM_TYPE}
                                                        groupConfDetails={this.getConfDetails([...tempdata.parentArray, key])}
                                                        groupTitle={key}
                                                        tempdata={tempdata}
                                                        parent={[...tempdata.parentArray, key]}
                                                    />
                                                </div>
                                            </div>
                                            <div className='config-input-area'>
                                                <div className='array-input-wrapper' >
                                                    <div className='array-input-group go-float-left' key={tempdata.data[key].length}>
                                                        {
                                                            tempdata.data[key].length ?
                                                                tempdata.data[key].map((elem, j) => {
                                                                    if (elem.length < 5) {
                                                                        arraycontainerClassName = 'array-input-box field-size-xxs';
                                                                    } else if (elem.length < 10) {
                                                                        arraycontainerClassName = 'array-input-box field-size-xs';
                                                                    } else if (elem.length < 22) {
                                                                        arraycontainerClassName = 'array-input-box field-size-sm';
                                                                    } else if (elem.length < 45) {
                                                                        arraycontainerClassName = 'array-input-box field-size-md';
                                                                    } else if (elem.length < 70) {
                                                                        arraycontainerClassName = 'array-input-box field-size-lg';
                                                                    } else {
                                                                        arraycontainerClassName = 'array-input-box field-size-xl';
                                                                    }

                                                                    if (elem.length === 0) {
                                                                        arraycontainerClassName = 'array-input-box field-size-sm';
                                                                    }
                                                                    return (
                                                                        <div className={arraycontainerClassName} key={j}>
                                                                            <input type='text' className='form-control array-input' autoComplete='off' placeholder='Type here...' defaultValue={elem} onChange={(e) => {
                                                                                this.inputUpdate(e, [...tempdata.parentArray, key], props, true, null, tempdata.data[key], j);
                                                                            }} onPaste={(e) => {
                                                                                this.inputUpdate(e, [...tempdata.parentArray, key], props, true, null, tempdata.data[key], j);
                                                                            }} />
                                                                            {tempdata.data[key].length > 0 ? this.loadRemoveIcon([...tempdata.parentArray, key], props, tempdata.data[key], j, 'arrAttachment') : null}
                                                                        </div>
                                                                    );
                                                                }) : null
                                                        }
                                                    </div>
                                                    <div className='array-icon-button-wrapper go-float-left'>
                                                        <Buttton
                                                            title='Add Options'
                                                            className='eb-icon-btn-style add-array-btn'
                                                            type='button'
                                                            value={this.addSelectBotValue()}
                                                            buttonOnClick={(e) => {
                                                                let currentBotData = editableBotData;
                                                                let parentLength = tempdata.parentArray.length;
                                                                let parentArray = tempdata.parentArray;

                                                                if (parentLength === 2) {
                                                                    if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                                                                        currentBotData[tempdata.parentArray[0]][tempdata.parentArray[1]][key].push('');
                                                                    } else {
                                                                        currentBotData.UI_OPTIONS[tempdata.parentArray[0]][tempdata.parentArray[1]][key].push('');
                                                                    }
                                                                } else if (parentLength === 3) {
                                                                    if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                                                                        currentBotData[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][key].push('');
                                                                    } else {
                                                                        currentBotData.UI_OPTIONS[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][key].push('');
                                                                    }
                                                                } else if (parentLength === 4) {
                                                                    if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                                                                        currentBotData[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][tempdata.parentArray[3]][key].push('');
                                                                    } else {
                                                                        currentBotData.UI_OPTIONS[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][tempdata.parentArray[3]][key].push('');
                                                                    }
                                                                } else if (parentLength === 5) {
                                                                    if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                                                                        currentBotData[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][tempdata.parentArray[3]][tempdata.parentArray[4]][key].push('');
                                                                    } else {
                                                                        currentBotData.UI_OPTIONS[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][tempdata.parentArray[3]][tempdata.parentArray[4]][key].push('');
                                                                    }
                                                                }

                                                                props.updateBotValue(currentBotData);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={containerClassName}></div>
                                            {parentMatch ? this.executeScroll() : null}
                                        </div>
                                    );
                                } else {
                                    if (typeof (tempdata.data[key]) === 'object' && key !== 'PAYLOAD') {
                                        return (
                                            <div className='config-group-block' key={i}>
                                                {parentMatch ? this.addTempDivToScroll() : null}
                                                <div className='config-label'>
                                                    <label className={labelClassName}>{this.getReadableName(key)}</label>
                                                    <div className='more-options-btn-wrapper popover-inactive'>
                                                        <PopOverMenu
                                                            groupDesc={tempdata.data.ELEM_DESC}
                                                            groupType={tempdata.data.ELEM_TYPE}
                                                            groupConfDetails={this.getConfDetails(tempdata.parentArray)}
                                                            groupTitle={tempdata.title}
                                                            tempdata={tempdata}
                                                            parent={[...tempdata.parentArray, key]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='config-input-area'>
                                                    {this.addInputOnType({ ...tempdata, data: tempdata.data[key], title: key, parentArray: [...tempdata.parentArray, key] }, props)}
                                                </div>
                                                {parentMatch ? this.executeScroll() : null}
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div className='config-group-block' key={i}>
                                                {parentMatch ? this.addTempDivToScroll() : null}
                                                <div className='config-label'>
                                                    <label className={labelClassName}>{this.getReadableName(key)}</label>
                                                    <div className='more-options-btn-wrapper popover-inactive'>
                                                        <PopOverMenu
                                                            groupDesc={tempdata.data.ELEM_DESC}
                                                            groupType={tempdata.data.ELEM_TYPE}
                                                            groupConfDetails={this.getConfDetails(tempdata.parentArray)}
                                                            groupTitle={tempdata.title}
                                                            tempdata={tempdata}
                                                            parent={[...tempdata.parentArray, key]}
                                                        />
                                                    </div>
                                                </div>
                                                {this.attchmentDistributor({ ...tempdata, data: tempdata.data[key], title: key, parentArray: [...tempdata.parentArray, key] }, props)}
                                                {parentMatch ? this.executeScroll() : null}
                                            </div>
                                        );

                                    }
                                }
                            } else {
                                return (
                                    <div className='config-input-block' key={i}>
                                        {parentMatch ? this.addTempDivToScroll() : null}
                                        <div className='config-label'>
                                            <label className={labelClassName}>{this.getReadableName(key)}</label>
                                            <div className='more-options-btn-wrapper popover-inactive'>
                                                <PopOverMenu
                                                    groupDesc={'Attachment Object'}
                                                    groupType={tempdata.data.ELEM_TYPE}
                                                    groupConfDetails={this.getConfDetails([...tempdata.parentArray, key])}
                                                    groupTitle={key}
                                                    tempdata={tempdata}
                                                    parent={[...tempdata.parentArray, key]}
                                                />
                                            </div>
                                        </div>
                                        <div className='config-input-area'>
                                            <div className={containerClassName}>
                                                <input className='form-control character-input' type='text' placeholder='Type here...' autoComplete='off' defaultValue={tempdata.data[key]} onChange={(e) => {
                                                    this.inputUpdate(e, [...tempdata.parentArray, key], props, null, null, null, null, true);
                                                }} onPaste={(e) => {
                                                    this.inputUpdate(e, [...tempdata.parentArray, key], props, null, null, null, null, true);
                                                }} />
                                            </div>
                                        </div>
                                        <div className={containerClassName}></div>
                                        {parentMatch ? this.executeScroll() : null}
                                    </div>
                                );
                            }
                        })
                    }
                </div>
                <div className='icon-button-wrapper go-float-right'>
                    <CreatePopMenu
                        className='eb-icon-btn-style add-new-input'
                        parentArray={tempdata.parentArray}
                    />
                </div>
            </div>
        );
    }

    imageUploadValidation = (e, parentArray, props) => {
        e.preventDefault();
        window.URL = window.URL || window.webkitURL;
        let that = this;
        this.props.blockUiFun(true);

        let files = e.currentTarget.files;

        if (files.length) {
            let img = new Image();
            img.src = window.URL.createObjectURL(files[0]);
            img.onload = function () {
                window.URL.revokeObjectURL(img.src);
                upload(files, false, (reponseUrl) => {
                    that.inputUpdate(e, parentArray, props, false, [], null, null, null, 'image', reponseUrl);
                    that.props.blockUiFun(false);
                }, (err) => {
                    if (err && err.status && err.status === 401) {
                        that.props.reloginUser();
                    }
                    that.props.blockUiFun(false);
                });
            };
        }
        else {
            this.props.blockUiFun(false);
            console.log('file not found');
        }
    }

    beforeinputUpdate = (e, parentArray, props, i, data) => {
        let tempdataUpdate = data.VALUE;
        let currentInputValue = e.target.value;
        if (i !== 3) {
            currentInputValue = parseFloat(currentInputValue);
        }
        tempdataUpdate[i].VALUE = currentInputValue;
        this.inputUpdate(e, parentArray, props, false, [], null, null, null, 'drop-shadow', tempdataUpdate);
    }

    beforeImgUpdate = (e, val, imageType, parentArray, props, data, isDeleted) => {
        let currentSelVal = val;
        let tempDataToUpdate = data;
        if (imageType) {
            tempDataToUpdate.IMAGE.STATUS = true;
            tempDataToUpdate.IMAGE.VALUE = currentSelVal;
            tempDataToUpdate.ICON.STATUS = false;
            tempDataToUpdate.ICON.VALUE = '';
            tempDataToUpdate.VALUE = currentSelVal;

        } else {
            tempDataToUpdate.ICON.STATUS = true;
            tempDataToUpdate.ICON.VALUE = tempDataToUpdate.ARRAY[currentSelVal];
            tempDataToUpdate.IMAGE.STATUS = false;
            tempDataToUpdate.IMAGE.VALUE = !isDeleted ? data.IMAGE.VALUE !== '' ? data.IMAGE.VALUE : '' : '';
            tempDataToUpdate.VALUE = tempDataToUpdate.ARRAY[currentSelVal];
        }
        this.inputUpdate(e, parentArray, props, false, [], null, null, null, 'img-arr', tempDataToUpdate);
    }

    calculateWidth = (text) => {
        let tempDiv = document.createElement('div');
        tempDiv.className = 'botforge-input-length-calculator';
        tempDiv.innerText = text;
        document.getElementById('botForge').appendChild(tempDiv);
        let tempWidth = `${tempDiv.offsetWidth + 30}px`;
        const elements = document.getElementsByClassName("botforge-input-length-calculator");
        while (elements.length > 0) elements[0].remove();
        return tempWidth;
    }

    numberFieldOnChangeHandler = (e, tempdata, props) => {
        const currentValue = e.target.value;

        if(tempdata.title === 'MAX_SESSIONS') {
            const currVal = parseInt(currentValue);
            if(currVal > 11 || currVal < 1) {
                if(currVal > 10) {
                    e.target.value = 10;
                } else if(currVal < 1) {
                    e.target.value = 1;
                }
                alert('Max session count should be in the range of 1 to 10');
            }
        // } else if (tempdata.parentArray.includes('CHAT_AUTO_OPEN') ) {
        } else if (tempdata.title === 'DELAY') {
            const currVal = parseInt(currentValue);
            if(currVal < 1) {
                e.target.value = 1;
                alert('Minimum delay should be greater than 0');
            }
        }

        this.inputUpdate(e, tempdata.parentArray, props);
    }

    numberFieldOnBlurHandler = (e, tempdata, props) => {
        const currentValue = e.target.value;
        if(tempdata.title === 'MAX_SESSIONS') {
            if(currentValue === '') {
                e.target.value = 1;
                alert('Max session count should be in the range of 1 to 10');
            }
        } else if (tempdata.title === 'DELAY') {
            if(currentValue === '') {
                e.target.value = 1;
                alert('Minimum delay cannot be empty');
            }
        }

        this.inputUpdate(e, tempdata.parentArray, props);
    }

    addInputOnType = (tempdata, props) => {
        const tempdataKeysArray = Object.keys(tempdata.data);
        const timeStamp = new Date().getTime() + parseInt(Math.random() * 1000);
        let editableBotData = props.tempdata.isGeneric ? props.genericBotData : props.editableBotData;
        // console.log('addinput type',      tempdata.data.ELEM_TYPE  )

        const { title, parentArray } = tempdata;
        // const  textFieldOnChange = () => {
        //     const currentValue = e.target.value;

        //     console.log('currentValue', currentValue);

        //     if(title === 'CHAT_AUTO_OPEN') {
        //         const currVal = e.target.value;
        //         if(currVal && currVal < 1) {
        //             e.target.value = 1;
        //             alert('Minimum delay should be greater than 0.');
        //         }
        //     }
        //     this.inputUpdate(e, tempdata.parentArray, props);
        // }

        if (tempdata.data.ELEM_TYPE) {
            switch (tempdata.data.ELEM_TYPE) {
                case 'switch-toggle':
                    const tempChildId = 'toggle-theme-creator' + timeStamp;
                    const tempChildName = 'Toggle Button' + timeStamp;
                    return (
                        <ToggleButton
                            className='switch-toggle-wrapper go-float-left'
                            inputClassName='switch-input'
                            childId={tempChildId}
                            inputName={tempChildName}
                            labelClassName='switch-label'
                            togglerState={tempdata.data.VALUE}
                            toggleClicked={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                            }}
                        />
                    );

                case 'text-field':
                    let containerClassName = 'character-input-box';
                    // if(tempdata.data.VALUE.length < 11) {
                    //     containerClassName = 'character-input-box field-size-xs';
                    // } else if(tempdata.data.VALUE.length < 22) {
                    //     containerClassName = 'character-input-box field-size-sm';
                    // } else if (tempdata.data.VALUE.length < 45) {
                    //     containerClassName = 'character-input-box field-size-md';
                    // } else if (tempdata.data.VALUE.length < 70) {
                    //     containerClassName = 'character-input-box field-size-lg';
                    // } else {
                    //     containerClassName = 'character-input-box field-size-xl';
                    // }
                    let isBotLang = tempdata.parentArray[tempdata.parentArray.length - 1] === 'BOT_LANG';
                    let isLSPrefix = tempdata.parentArray[tempdata.parentArray.length - 1] === 'LS_PREFIX';
                    return (
                        <div className={containerClassName}>
                            <input className='form-control character-input' style={{ 'width': this.calculateWidth(tempdata.data.VALUE), 'maxWidth': '620px' }} type='text' placeholder='Type here...' autoComplete='off' defaultValue={tempdata.data.VALUE} onChange={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                                // e.target.style.width = e.target.previousSibling.offsetWidth + 30 + 'px';
                            }} onPaste={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                                // e.target.style.width = e.target.previousSibling.offsetWidth + 30 + 'px';
                            }} disabled={(isBotLang || isLSPrefix) ? 'disabled' : undefined} />
                        </div>
                    );

                case 'radio-toggle':
                    const radioToggleName = 'radio-header' + timeStamp + parseInt(Math.random() * 10000);
                    let radioToggleid = 'radio-header-text' + timeStamp + parseInt(Math.random() * 10000);
                    let tempRadioArray = tempdataKeysArray.filter(e => (e !== 'ELEM_TYPE' && e !== 'ELEM_DESC'));
                    // let newUi = this.props.editableBotData?.CHATBOT?.CUSTOMISE_YOUR_BOT?.USER_INTERFACE?.New && this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT.USER_INTERFACE.New === true ? true : false;

                    // if(tempdata.title && tempdata.title === 'USER_INTERFACE') {
                    //     if(newUi) {
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_JS.USER_DEFAULT_JS.NEW_UI.REQUIRED.VALUE = true;
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_JS.USER_DEFAULT_JS.NEW_UI_FEEDBACK_PAGE.REQUIRED.VALUE = true;
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_CSS.USER_DEFAULT_CSS.NEW_UI.REQUIRED.VALUE = true;
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_CSS.USER_DEFAULT_CSS.NEW_UI_MEDIA_QUERY.REQUIRED.VALUE = true;
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_CSS.EB_IFRAME_CSS_FILES.NEW_UI_IFRAME.REQUIRED.VALUE = true;

                    //         // for oldUI files
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_JS.USER_DEFAULT_JS.OLD_UI_FEEDBACK_PAGE.REQUIRED.VALUE = false;
                    //     } else if(this.props.editableBotData?.UI_OPTIONS?.CUSTOM_JS?.USER_DEFAULT_JS?.NEW_UI?.REQUIRED?.VALUE) {
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_JS.USER_DEFAULT_JS.NEW_UI.REQUIRED.VALUE = false;
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_JS.USER_DEFAULT_JS.NEW_UI_FEEDBACK_PAGE.REQUIRED.VALUE = false;
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_CSS.USER_DEFAULT_CSS.NEW_UI.REQUIRED.VALUE = false;
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_CSS.USER_DEFAULT_CSS.NEW_UI_MEDIA_QUERY.REQUIRED.VALUE = false;
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_CSS.EB_IFRAME_CSS_FILES.NEW_UI_IFRAME.REQUIRED.VALUE = false;
                            
                    //         // for oldUI files
                    //         this.props.editableBotData.UI_OPTIONS.CUSTOM_JS.USER_DEFAULT_JS.OLD_UI_FEEDBACK_PAGE.REQUIRED.VALUE = true;
                    //     }
                    // }

                    let optionalGroupParent = [...tempdata.parentArray]
                    if(tempdata.optionalGroup) {
                        optionalGroupParent.pop();
                    }

                    return (
                        <div className='radio-btn-set go-float-left'>
                            {
                                tempRadioArray.map((key, i) => {
                                    if (key !== 'ELEM_TYPE' && key !== 'ELEM_DESC') {
                                        if (tempdata.data[key]) {
                                            return (
                                                <div className='md-radio md-radio-inline' key={i}>
                                                    <input type='radio' defaultChecked id={radioToggleid + i} name={radioToggleName} onClick={(e) => {
                                                        tempdata.optionalGroup ? props.updateBotValue(updateSpecificValue(key, optionalGroupParent, editableBotData, 'text')) : '';
                                                        this.inputUpdate(e, [...tempdata.parentArray, key], props, false, tempRadioArray);
                                                    }} onPaste={(e) => {
                                                        tempdata.optionalGroup ? props.updateBotValue(updateSpecificValue(key, optionalGroupParent, editableBotData, 'text')) : '';
                                                        this.inputUpdate(e, [...tempdata.parentArray, key], props, false, tempRadioArray);
                                                    }} />
                                                    <label htmlFor={radioToggleid + i}>{key}</label>
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <div className='md-radio md-radio-inline' key={i}>
                                                    <input type='radio' defaultValue={tempdata.data[key]} id={radioToggleid + i} name={radioToggleName} onClick={(e) => {
                                                        tempdata.optionalGroup ? props.updateBotValue(updateSpecificValue(key, optionalGroupParent, editableBotData, 'text')) : '';
                                                        this.inputUpdate(e, [...tempdata.parentArray, key], props, false, tempRadioArray);
                                                    }} onPaste={(e) => {
                                                        tempdata.optionalGroup ? props.updateBotValue(updateSpecificValue(key, optionalGroupParent, editableBotData, 'text')) : '';
                                                        this.inputUpdate(e, [...tempdata.parentArray, key], props, false, tempRadioArray);
                                                    }} />
                                                    <label htmlFor={radioToggleid + i}>{key}</label>
                                                </div>
                                            );
                                        }
                                    } else {
                                        return '';
                                    }
                                })
                            }
                        </div>
                    );

                case 'number-field':
                    return (
                        <>
                            <div className='character-input-box field-size-xs'>
                                <input className='form-control character-input' type='number' placeholder='Type here...' autoComplete='off' pattern='\d*' defaultValue={tempdata.data.VALUE} onChange={(e) => this.numberFieldOnChangeHandler(e, tempdata, props)} onPaste={(e) => this.numberFieldOnChangeHandler(e, tempdata, props)} onBlur={(e) => this.numberFieldOnBlurHandler(e, tempdata, props)} />
                                {/* onChange={(e) => {
                                    if(tempdata.title === 'MAX_SESSIONS') {
                                        let currVal = parseInt(e.target.value);
                                        if(currVal && currVal < 11 && currVal > 0) {
                                            this.inputUpdate(e, tempdata.parentArray, props);
                                        } else {
                                            if(currVal > 10) {
                                                e.target.value = 10;
                                                this.inputUpdate(e, tempdata.parentArray, props);
                                            } else if(currVal < 1) {
                                                e.target.value = 1;
                                                this.inputUpdate(e, tempdata.parentArray, props);
                                            } else {
                                                this.inputUpdate(e, tempdata.parentArray, props);
                                            }
                                            alert('Max session count should be in the range of 1 to 10');
                                            return false;
                                        }
                                    } else {
                                        this.inputUpdate(e, tempdata.parentArray, props);
                                    }
                                    
                                    const { title, parentArray } = tempdata;
                                    if (title === 'CHAT_AUTO_OPEN') {
                                        const value = e?.target?.value?.trim();
                                        const currVal = parseInt(value, 10);

                                        if (!isNaN(currVal) && currVal > 0) {
                                            this.inputUpdate(e, parentArray, props);
                                        } else {
                                            e.target.value = 1;
                                            this.inputUpdate(e, parentArray, props);
                                            alert('Minimum delay should be greater than 0.');
                                        }
                                    } else {
                                        this.inputUpdate(e, parentArray, props);
                                    }
                                }} onPaste={(e) => {
                                    if(tempdata.title === 'MAX_SESSIONS') {
                                        let currVal = parseInt(e.target.value);
                                        if(currVal && currVal < 11 && currVal > 0) {
                                            this.inputUpdate(e, tempdata.parentArray, props);
                                        } else {
                                            alert('Max session count should be in the range of 1 to 10');
                                            if(currVal > 10) {
                                                e.target.value = 11;
                                                this.inputUpdate(e, tempdata.parentArray, props);
                                            } else if(currVal < 1) {
                                                e.target.value = 0;
                                                this.inputUpdate(e, tempdata.parentArray, props);
                                            }
                                            return false;
                                        }
                                    } else {
                                        this.inputUpdate(e, tempdata.parentArray, props);
                                    }
                                    const { title, parentArray } = tempdata;
                                    if (title === 'CHAT_AUTO_OPEN') {
                                        const value = e?.target?.value?.trim();
                                        const currVal = parseInt(value, 10);

                                        if (!isNaN(currVal) && currVal > 0) {
                                            this.inputUpdate(e, parentArray, props);
                                        } else {
                                            e.target.value = 1;
                                            this.inputUpdate(e, parentArray, props);
                                            alert('Minimum delay should be greater than 0.');
                                        }
                                    } else {
                                        this.inputUpdate(e, parentArray, props);
                                    }
                                }} /> */}
                            </div>
                            {
                                tempdata.data.UNIT ? <span className='config-unit-span'>{tempdata.data.UNIT}</span> : null
                            }
                        </>
                    );

                case 'attach-js-field':
                    return (
                        <div className='character-input-box field-size-sm'>
                            <input className='form-control character-input' type='text' data-seq={tempdata.data.seq} data-link='customjs' placeholder='Type here...' autoComplete='off' defaultValue={tempdata.data.VALUE} onChange={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                            }} onPaste={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                            }} />
                        </div>
                    );

                case 'attach-css-field':
                    return (
                        <div className='character-input-box field-size-sm'>
                            <input className='form-control character-input' type='text' data-link='customcss' placeholder='Type here...' autoComplete='off' defaultValue={tempdata.data.VALUE} onChange={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                            }} onPaste={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                            }} />
                        </div>
                    );

                case 'array-field':
                    let arraycontainerClassName = 'array-input-box';
                    return (
                        <div className='array-input-wrapper' >
                            <div className='array-input-group go-float-left' key={tempdata.data.VALUE.length}>
                                {
                                    tempdata.data.VALUE.length ?
                                        tempdata.data.VALUE.map((elem, i) => {
                                            if (elem.length < 5) {
                                                arraycontainerClassName = 'array-input-box field-size-xxs';
                                            } else if (elem.length < 11) {
                                                arraycontainerClassName = 'array-input-box field-size-xs';
                                            } else if (elem.length < 22) {
                                                arraycontainerClassName = 'array-input-box field-size-sm';
                                            } else if (elem.length < 45) {
                                                arraycontainerClassName = 'array-input-box field-size-md';
                                            } else if (elem.length < 70) {
                                                arraycontainerClassName = 'array-input-box field-size-lg';
                                            } else {
                                                arraycontainerClassName = 'array-input-box field-size-xl';
                                            }

                                            if (elem.length === 0) {
                                                arraycontainerClassName = 'array-input-box field-size-sm';
                                            }
                                            return (
                                                <div className={arraycontainerClassName} key={i}>
                                                    <input type='text' className='form-control array-input' autoComplete='off' placeholder='Type here...' defaultValue={elem} onChange={(e) => {
                                                        this.inputUpdate(e, tempdata.parentArray, props, true, null, tempdata.data.VALUE, i);
                                                    }} onPaste={(e) => {
                                                        this.inputUpdate(e, tempdata.parentArray, props, true, null, tempdata.data.VALUE, i);
                                                    }} />
                                                    {tempdata.data.VALUE.length > 0 ? this.loadRemoveIcon(tempdata.parentArray, props, tempdata.data.VALUE, i) : null}
                                                </div>
                                            );
                                        }) : null
                                }
                            </div>
                            <div className='array-icon-button-wrapper go-float-left'>
                                <Buttton
                                    title='Add Options'
                                    className='eb-icon-btn-style add-array-btn'
                                    type='button'
                                    value={this.addSelectBotValue()}
                                    buttonOnClick={(e) => {
                                        let currentBotData = editableBotData;
                                        let parentLength = tempdata.parentArray.length;
                                        let parentArray = tempdata.parentArray;

                                        if (parentLength === 2) {
                                            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                                                currentBotData[tempdata.parentArray[0]][tempdata.parentArray[1]].VALUE.push('');
                                            } else {
                                                currentBotData.UI_OPTIONS[tempdata.parentArray[0]][tempdata.parentArray[1]].VALUE.push('');
                                            }
                                        } else if (parentLength === 3) {
                                            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                                                currentBotData[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]].VALUE.push('');
                                            } else {
                                                currentBotData.UI_OPTIONS[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]].VALUE.push('');
                                            }
                                        } else if (parentLength === 4) {
                                            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                                                currentBotData[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][tempdata.parentArray[3]].VALUE.push('');
                                            } else {
                                                currentBotData.UI_OPTIONS[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][tempdata.parentArray[3]].VALUE.push('');
                                            }
                                        } else if (parentLength === 5) {
                                            if (parentArray[0] === 'SETTINGS' || parentArray[0] === 'CHATBOT' || parentArray[0] === 'POST_OPTIONS' || parentArray[0] === 'OPTIONS') {
                                                currentBotData[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][tempdata.parentArray[3]][tempdata.parentArray[4]].VALUE.push('');
                                            } else {
                                                currentBotData.UI_OPTIONS[tempdata.parentArray[0]][tempdata.parentArray[1]][tempdata.parentArray[2]][tempdata.parentArray[3]][tempdata.parentArray[4]].VALUE.push('');
                                            }
                                        }

                                        props.updateBotValue(currentBotData);
                                    }}
                                />
                            </div>
                        </div>
                    );

                case 'color-field':
                    let containerClassName1 = 'character-input-box';
                    if (tempdata.data.VALUE.length < 11) {
                        containerClassName1 = 'character-input-box field-size-xs';
                    } else if (tempdata.data.VALUE.length < 22) {
                        containerClassName1 = 'character-input-box field-size-sm';
                    } else if (tempdata.data.VALUE.length < 45) {
                        containerClassName1 = 'character-input-box field-size-md';
                    } else if (tempdata.data.VALUE.length < 70) {
                        containerClassName1 = 'character-input-box field-size-lg';
                    } else {
                        containerClassName1 = 'character-input-box field-size-xl';
                    }
                    return (
                        <div className={containerClassName1}>
                            <input className='form-control character-input' type='text' placeholder='Type here...' autoComplete='off' defaultValue={tempdata.data.VALUE} onChange={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                            }} onPaste={(e) => {
                                this.inputUpdate(e, tempdata.parentArray, props);
                            }} />
                        </div>
                    );

                case 'color-array-field':
                    let tempId = 'addColor' + timeStamp + parseInt(Math.random() * 10000);
                    return (
                        <>
                            <div className='character-input-box'>
                                {
                                    tempdata.data.ARRAY.map((elm, i) => {
                                        if (i >= tempdata.data.MAX_LENGTH) {
                                            return '';
                                        } else {
                                            if (elm === false) {
                                                return (
                                                    <div className={'color-input-container' + (tempdata.data.VALUE === elm ? ' active' : '')} key={i} id={tempdata + i}>
                                                        <div className='color-input-inner-container false-color' value={elm} onClick={(e) => { this.inputUpdate(e, tempdata.parentArray, props, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'false') }}>
                                                            <img className='form-control color-image' height='28' width='28' alt="trnasparent" src={BLOCK_ICON} />
                                                        </div>
                                                    </div>
                                                );
                                            } else if (elm.indexOf('gradient') > -1) {
                                                return (
                                                    <div className={'color-input-container' + (tempdata.data.VALUE === elm ? ' active' : '')} key={i} id={tempdata + i}>
                                                        <div className='color-input-inner-container false-color' value={elm} onClick={(e) => { this.inputUpdate(e, tempdata.parentArray, props, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'gradient', elm) }}>
                                                            <div className='form-control color-gradient-box' style={{ 'background': elm, height: '28px', height: '28px' }}></div>
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <div className={'color-input-container' + (tempdata.data.VALUE === elm ? ' active' : '')} key={i} id={tempdata + i}>
                                                        <div className='color-input-wrapper-overlay' value={elm} onClick={(e) => { this.inputUpdate(e, tempdata.parentArray, props, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'color', elm) }}></div>
                                                        <div className='color-input-inner-container' value={elm} onClick={(e) => { this.inputUpdate(e, tempdata.parentArray, props) }}>
                                                            <input className='form-control color-input' type='color' placeholder='Type here...' autoComplete='off' disabled data-prefilled='true' pattern='\d*' defaultValue={elm} />
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        }
                                    })
                                }
                                <div className={'color-input-container add-color-icon' + (tempdata.data.ARRAY.length > tempdata.data.MAX_LENGTH ? ' hidden' : '') + ((tempdata.data.ARRAY.length > tempdata.data.MAX_LENGTH) && (tempdata.data.ARRAY.indexOf(tempdata.data.VALUE) === tempdata.data.MAX_LENGTH) ? ' active' : '')}>
                                    <div className='color-input-inner-container'>
                                        <span className='color-selected' style={{
                                            'backgroundColor': tempdata.data.VALUE
                                        }}></span>
                                        <label htmlFor={tempId + 9}>
                                            <ColorPopOver
                                                selectedColor={tempdata.data.VALUE}
                                                onUplaod={(e, val) => {
                                                    let tempArrayElm = tempdata.data.ARRAY.slice(0, tempdata.data.MAX_LENGTH);
                                                    let tempoData = tempdata.data;
                                                    if (val.length === 0) {
                                                        let currIndex = tempArrayElm.indexOf(tempdata.data.VALUE);
                                                        if (currIndex > -1) {
                                                            tempoData.VALUE = tempdata.data.ARRAY[currIndex];
                                                            tempArrayElm.push(tempdata.data.ARRAY[currIndex]);
                                                        } else {
                                                            tempoData.VALUE = tempdata.data.ARRAY[0];
                                                        }
                                                    } else {
                                                        tempoData.VALUE = val;
                                                        tempArrayElm.push(val);
                                                    }
                                                    tempoData.ARRAY = tempArrayElm;
                                                    this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'color-array-field', tempoData);
                                                }}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {
                                tempdata.data.UNIT ? <span className='config-unit-span'>{tempdata.data.UNIT}</span> : null
                            }
                        </>
                    );

                case 'image-field':
                    let tempImgGId1 = 'addImage' + timeStamp + parseInt(Math.random() * 10000);
                    let currentFileNameArr = tempdata.data.VALUE.split('/');
                    let currentFileName = currentFileNameArr[currentFileNameArr.length - 1];
                    return (
                        <div className='character-input-box'>
                            <div className={'image-input-container attachment'} id={tempImgGId1 + 9}>
                                {currentFileName}
                                <label htmlFor={tempImgGId1 + 10} className={'image-upload-label' + (currentFileName.length > 0 ? ' hidden' : '')}>
                                    <img src={attachImage} alt='Attach Img' />Attach Image
                                </label>
                                <input id={tempImgGId1 + 10} type='file' accept="image/x-png, image/jpeg, image/svg" defaultValue={''} className='' onChange={(e) => { this.imageUploadValidation(e, tempdata.parentArray, props) }} />
                            </div>
                        </div>
                    );

                case 'image-group-field':
                    let tempImgGId = 'addImage' + timeStamp + parseInt(Math.random() * 10000);
                    return (
                        <div className='character-input-box'>
                            <div className={'image-input-container-wrapper' + (tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? '' : ' active')}>
                                {
                                    tempdata.data.VALUE.map((elm, i) => {
                                        return (
                                            <div className={'image-input-container'} key={i} id={tempImgGId + i} >
                                                {elm.indexOf('http') > -1 ? <img src={elm} alt='icon' /> : <i className={'eb-smiley-icons eb-icons ' + elm} style={{fontSize: '24px', lineHeight: '24px'}}></i>}
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            <div className={'image-input-container-wrapper' + (tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? ' active' : ' hide')}>
                                {
                                    tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? tempdata.data.CUSTOM.map((elm, i) => {
                                        return (
                                            <div className={'image-input-container'} key={i} id={tempImgGId + i + i} >
                                                {elm.indexOf('http') > -1 ? <img src={elm} alt='icon' /> : <i className={'eb-smiley-icons eb-icons ' + elm} style={{fontSize: '24px', lineHeight: '24px'}}></i>}
                                            </div>
                                        );
                                    }) : ''
                                }

                                <label className='image-container-clickable-label' htmlFor={tempImgGId + 9}>
                                    {/* {checkFeatureFlag('FEATURE_MESSAGEFEEDBACK') ? <MultyImagePopOverNew
                                        onUplaod={(e, val) => {
                                            if (val && val.length) {
                                                let tempObj1 = {};
                                                tempObj1.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj1.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj1.VALUE = tempdata.data.VALUE;
                                                tempObj1.CUSTOM = val;
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj1);
                                            } else {
                                                let tempObj = {};
                                                tempObj.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj.VALUE = tempdata.data.VALUE;
                                                tempObj.CUSTOM = [];
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj);
                                            }
                                        }}
                                        custom={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? tempdata.data.CUSTOM : []}
                                        hasImageData={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? true : false}
                                    />
                                    :
                                    <MultyImagePopOver
                                        onUplaod={(e, val) => {
                                            if (val && val.length) {
                                                let tempObj1 = {};
                                                tempObj1.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj1.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj1.VALUE = tempdata.data.VALUE;
                                                tempObj1.CUSTOM = val;
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj1);
                                            } else {
                                                let tempObj = {};
                                                tempObj.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj.VALUE = tempdata.data.VALUE;
                                                tempObj.CUSTOM = [];
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj);
                                            }
                                        }}
                                        custom={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? tempdata.data.CUSTOM : []}
                                        hasImageData={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? true : false}
                                    />} */}
                                    <MultyImagePopOverNew
                                        onUplaod={(e, val) => {
                                            if (val && val.length) {
                                                let tempObj1 = {};
                                                tempObj1.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj1.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj1.VALUE = tempdata.data.VALUE;
                                                tempObj1.CUSTOM = val;
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj1);
                                            } else {
                                                let tempObj = {};
                                                tempObj.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj.VALUE = tempdata.data.VALUE;
                                                tempObj.CUSTOM = [];
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj);
                                            }
                                        }}
                                        custom={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? tempdata.data.CUSTOM : []}
                                        hasImageData={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? true : false}
                                    />
                                </label>
                            </div>
                            <div className={'image-input-container' + (tempdata.data.CUSTOM && (tempdata.data.CUSTOM.length > 0) ? ' hide' : '')} id={tempImgGId + 9}>
                                <label htmlFor={tempImgGId + 9}>
                                    {/* {checkFeatureFlag('FEATURE_MESSAGEFEEDBACK') ? <MultyImagePopOverNew
                                        onUplaod={(e, val) => {
                                            if (val && val.length) {
                                                let tempObj1 = {};
                                                tempObj1.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj1.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj1.VALUE = tempdata.data.VALUE;
                                                tempObj1.CUSTOM = val;
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj1);
                                            } else {
                                                let tempObj = {};
                                                tempObj.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj.VALUE = tempdata.data.VALUE;
                                                tempObj.CUSTOM = [];
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj);
                                            }
                                        }}
                                        custom={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? tempdata.data.CUSTOM : []}
                                        hasImageData={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? true : false}
                                    />
                                    :
                                    <MultyImagePopOver
                                        onUplaod={(e, val) => {
                                            if (val && val.length) {
                                                let tempObj1 = {};
                                                tempObj1.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj1.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj1.VALUE = tempdata.data.VALUE;
                                                tempObj1.CUSTOM = val;
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj1);
                                            } else {
                                                let tempObj = {};
                                                tempObj.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj.VALUE = tempdata.data.VALUE;
                                                tempObj.CUSTOM = [];
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj);
                                            }
                                        }}
                                        custom={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? tempdata.data.CUSTOM : []}
                                        hasImageData={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? true : false}
                                    />} */}
                                    <MultyImagePopOverNew
                                        onUplaod={(e, val) => {
                                            if (val && val.length) {
                                                let tempObj1 = {};
                                                tempObj1.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj1.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj1.VALUE = tempdata.data.VALUE;
                                                tempObj1.CUSTOM = val;
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj1);
                                            } else {
                                                let tempObj = {};
                                                tempObj.ELEM_TYPE = tempdata.data.ELEM_TYPE;
                                                tempObj.ELEM_DESC = tempdata.data.ELEM_DESC;
                                                tempObj.VALUE = tempdata.data.VALUE;
                                                tempObj.CUSTOM = [];
                                                this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'img-group-arr', tempObj);
                                            }
                                        }}
                                        custom={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? tempdata.data.CUSTOM : []}
                                        hasImageData={tempdata.data.CUSTOM && tempdata.data.CUSTOM.length ? true : false}
                                    />
                                </label>
                            </div>
                        </div>
                    );

                case 'image-array-field':
                    let tempImgId = 'addImage' + timeStamp + parseInt(Math.random() * 10000);
                    return (
                        <div className='character-input-box'>
                            {
                                tempdata.data.ARRAY.map((elm, i) => {
                                    return (
                                        <div className={'image-input-container' + (tempdata.data.VALUE === elm ? ' active' : '')} key={i} id={tempImgId + i} onClick={(e) => { this.beforeImgUpdate(e, i, false, tempdata.parentArray, props, tempdata.data) }}>
                                            {
                                                typeof elm === 'boolean' ? <img src={BLOCK_ICON} alt='no Image' className='no-image' /> :
                                                elm.indexOf('http') > -1 ? <img src={elm} alt='icon' /> : <i className={'eb-icons ' + elm}></i>
                                            }
                                        </div>
                                    );
                                })
                            }
                            <div className={'image-input-container uploaded' + (tempdata.data.IMAGE.STATUS ? ' active' : '') + (tempdata.data.IMAGE.VALUE !== '' ? ' has-image' : '')} id={tempImgId + 9}>
                                <img className='outer-img' src={tempdata.data.IMAGE.VALUE !== '' ? tempdata.data.IMAGE.VALUE : tempdata.data.VALUE} alt='uploaded img' />
                                <label className={'outer-label' + (tempdata.data.IMAGE.VALUE !== '' ? ' has-image' : '')} htmlFor={tempImgId + 9}>
                                    <ImagePopOver
                                        imageUrl={tempdata.data.IMAGE.VALUE !== '' ? tempdata.data.IMAGE.VALUE : ''}
                                        beforeImgUpdate={(e, val) => { this.beforeImgUpdate(e, val, true, tempdata.parentArray, props, tempdata.data); }}
                                        onUplaod={(e, val, isDeleted) => {
                                            if (val === '') {
                                                this.beforeImgUpdate(e, 0, false, tempdata.parentArray, props, tempdata.data, isDeleted);
                                            } else {
                                                this.beforeImgUpdate(e, val, true, tempdata.parentArray, props, tempdata.data, isDeleted);
                                            }
                                        }}
                                    />
                                </label>
                            </div>
                        </div>
                    );

                case 'input-array-group-field':
                    let tempboxId = 'addbox' + timeStamp + parseInt(Math.random() * 10000);
                    return (
                        <div className='drop-shadow-container'>
                            {
                                tempdata.data.VALUE.map((elm, i) => {
                                    return (
                                        <div id={tempboxId + i} key={i} className='drop-shadow-container-box'>
                                            <div className={'character-input-box' + (i === 3 ? ' field-size-xs' : ' field-size-xs-small')}>
                                                <input className='form-control character-input' type={i === 3 ? 'text' : 'number'} maxLength={(i === 3 ? 7 : 5)} placeholder='Type here...' autoComplete='off' pattern='\d*' defaultValue={elm['VALUE']} onChange={(e) => {
                                                    this.beforeinputUpdate(e, tempdata.parentArray, props, i, tempdata.data);
                                                }} onPaste={(e) => {
                                                    this.beforeinputUpdate(e, tempdata.parentArray, props, i, tempdata.data);
                                                }} />
                                            </div>
                                            {
                                                elm.UNIT ? <span className='config-unit-span'>{elm.UNIT}</span> : null
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    );

                case 'dropdown-field':
                    return (
                        <div className={'drop-down-container' + (this.state.fontMenuOpen ? ' active' : '')}>
                            <div className={'dopdown-value-container'} onClick={() => { this.setState({ fontMenuOpen: !this.state.fontMenuOpen }) }}>
                                <span className='dropdown-value-title'>{tempdata.data.ARRAY[tempdata.data.VALUE].NAME}</span>
                                <img className={'dropdown-value-toggler' + (this.state.fontMenuOpen ? ' active' : '')} src={dropdownIcon} alt='drop-down' />
                            </div>
                            <div className='dropdown-menu-container'>
                                {
                                    tempdata.data.ARRAY.map((elm, i) => {
                                        return (
                                            <span className='dropdown-menu-container-item' key={i} onClick={(e) => { this.inputUpdate(e, tempdata.parentArray, props, false, [], null, null, null, 'drop-down', i); }}>{elm.NAME}</span>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    );

                default:
                    console.log(tempdata.data.ELEM_TYPE, ' type is not defined');
                    return '';
            }
        } else if (tempdata.data.TYPE) {
            return this.attchmentDistributor(tempdata, props);
        }
    }

    addTempDivToScroll = () => {
        return (<div ref={searchedNode => this.searchedNode = searchedNode}></div>)
    }

    scrollToRef = (ref) => {
        ref.scrollIntoView();
        // this.props.highlightSearchedResult({});
    }

    executeScroll = () => {
        setTimeout(() => {
            if (this.searchedNode)
                this.scrollToRef(this.searchedNode)
        }, 200)
    };

    render() {
        let parentMatch = false;
        if (this.props.highlightSearchedData && this.props.highlightSearchedData.parent) {
            parentMatch = JSON.stringify(this.props.tempdata.parentArray) === JSON.stringify(this.props.highlightSearchedData.parent);
        }
        const labelClassName = 'config-title' + (this.props.highlightSearchedData && this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length && parentMatch ? ' highlighted' : '');
        if (this.props.tempdata.isGeneric && !Object.keys(this.props.genericBotData).length) {
            return null;
        }

        // hide fields in UI
        if (this.props.tempdata && this.props.tempdata.title && (this.props.tempdata.title === 'DEFAULT_FULLSCREEN' || this.props.tempdata.title === 'USER_INTERFACE' || this.props.tempdata.title === 'THEME_CREATOR')) {
            // hidding default DEFAULT_FULLSCREEN functionality as it is not affecting any change to hybrid
            return null;
        }
        if (this.props.tempdata.data.ELEM_TYPE === 'optional-group') {
            return null;
        }
        return (
            <div className='config-input-block' ref={searchedNode => this.searchedNode = searchedNode}>
                {parentMatch ? this.addTempDivToScroll() : null}
                <div className='config-label'>
                    <label className={labelClassName}>{this.getReadableName(this.props.tempdata.title)}</label>
                    <div className='more-options-btn-wrapper popover-inactive'>
                        <PopOverMenu
                            groupDesc={this.props.tempdata.data.ELEM_DESC}
                            groupType={this.props.tempdata.data.ELEM_TYPE}
                            groupConfDetails={this.getConfDetails(this.props.tempdata.parentArray)}
                            groupTitle={this.props.tempdata.title}
                            parentMatch={parentMatch}
                            tempdata={this.props.tempdata}
                            parent={this.props.tempdata.parentArray}
                        />
                    </div>
                </div>

                <div className='config-input-area'>
                    {this.addInputOnType(this.props.tempdata, this.props)}
                </div>
                {parentMatch ? this.executeScroll() : null}
            </div>
        );
    }
}

const mapStateTothis = state => {
    return {
        selectedBotID: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : false,
        selectedBot: state.UiReducer && state.UiReducer.selectedBot && (state.UiReducer.selectedBot !== 'Select Bot') ? state.UiReducer.selectedBot : false,
        isCustomBot: state.UiReducer && state.UiReducer.isCustomBot ? state.UiReducer.isCustomBot : false,
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        selectedBotData: state.UiReducer && state.UiReducer.selectedBotData ? state.UiReducer.selectedBotData : false,
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : '',
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {},
        highlightSearchedData: state.UiReducer && state.UiReducer.highlightSearchedData ? state.UiReducer.highlightSearchedData : {},
    };
};

const mapDispatchTothis = dispatch => {
    return bindActionCreators({
        updateBotValue,
        highlightSearchedResult,
        blockUiFun,
        reloginUser
    },
        dispatch
    );
}

export default connect(
    mapStateTothis,
    mapDispatchTothis
)(SingleDataDistributor);